module.exports = __webpack_public_path__ + "static/media/chiefAccountant-1.6f133d97.png";